import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { MailCheck, MailX } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ConfirmPage() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setState("error");
      return;
    }
    axios
      .get(`${API}/waitlist/confirm/${token}`)
      .then(() => setState("ok"))
      .catch(() => setState("error"));
  }, [params]);

  return (
    <main className="pt-28 pb-24 min-h-[70vh] flex items-center" data-testid="confirm-page">
      <div className="max-w-md mx-auto px-5 text-center">
        {state === "loading" && <p className="text-[color:var(--ink-muted)]">Anmeldung wird bestätigt…</p>}
        {state === "ok" && (
          <div className="card-soft p-10" data-testid="confirm-success">
            <MailCheck size={44} className="mx-auto mb-5" style={{ color: "var(--gruen)" }} />
            <h1 className="font-display text-3xl font-medium mb-3">Anmeldung bestätigt!</h1>
            <p className="text-sm text-[color:var(--ink-muted)] leading-relaxed mb-8">
              Schön, dass du dabei bist. Wir melden uns, sobald es Neuigkeiten aus den VisualMA
              Lernwelten gibt.
            </p>
            <Link to="/" className="btn-primary" data-testid="confirm-home-link">Zur Startseite</Link>
          </div>
        )}
        {state === "error" && (
          <div className="card-soft p-10" data-testid="confirm-error">
            <MailX size={44} className="mx-auto mb-5" style={{ color: "var(--rot)" }} />
            <h1 className="font-display text-3xl font-medium mb-3">Link ungültig</h1>
            <p className="text-sm text-[color:var(--ink-muted)] leading-relaxed mb-8">
              Dieser Bestätigungslink ist ungültig oder abgelaufen. Bitte melde dich erneut an.
            </p>
            <Link to="/" className="btn-ghost">Zur Startseite</Link>
          </div>
        )}
      </div>
    </main>
  );
}
